import MxFormFileViewerFieldV2, {
  MxFormFileViewerFieldV2Props
} from "@rf-l2/form/files/MxFormFileViewerFieldV2";
import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";

interface MxFormL3FileViewerFieldV2Props extends MxFormFileViewerFieldV2Props {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3FileViewerFieldV2 = (props: MxFormL3FileViewerFieldV2Props) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormFileViewerFieldV2 label={props.label} {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3FileViewerFieldV2;
